import React from 'react';
import { TooltipProps as ReactTooltipProps } from 'react-tooltip';
import { BRAND } from '../../constants/main';
import { TooltipStyledAC } from './AC/TooltipStyled.AC';
import { TooltipStyledAP } from './AP/TooltipStyled.AP';
import { TooltipStyledDS } from './DS/TooltipStyled.DS';
import { TooltipStyledOV } from './OV/TooltipStyled.OV';
import { TooltipStyled } from './TooltipStyled';
import { SC } from '../../styles/theme';

export enum Place {
    top = 'top',
    right = 'right',
    bottom = 'bottom',
    left = 'left',
}
export enum Event {
    mouseenter = 'mouseenter',
    click = 'click',
}
interface OwnProps extends SC {
    handle: string | JSX.Element;
    page?: string;
}

export type TooltipProps = OwnProps & ReactTooltipProps;

const Tooltip = (props: TooltipProps) => {
    if (BRAND === 'AC') return <TooltipStyledAC {...props} />;
    if (BRAND === 'OV') return <TooltipStyledOV {...props} />;
    if (BRAND === 'AP') return <TooltipStyledAP {...props} />;
    if (BRAND === 'DS') return <TooltipStyledDS {...props} />;
    return <TooltipStyled {...props} />;
};

export default Tooltip;
